export const domHelperModule = angular
  .module('Q.helpers.dom-helper', [])

  .factory('domHelper', function ($q) {
    function whenImageLoaded(img) {
      const $img = angular.element(img);
      const _img = $img[0];
      if (_img && (!_img.complete || _img.naturalWidth === 0)) {
        // Image is not complete, set up listeners
        return $q((resolve, reject) => {
          $img
            .on('load', () => {
              resolve(img);
            })
            .on('error', () => {
              reject(img);
            });
        });
      } else {
        return $q.resolve(img);
      }
    }

    return {
      whenImageLoaded,
    };
  });
